import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router';
import { AppProviders } from '@/app/providers/AppProviders';
import { AppRouter } from '@/app/router';
// Import for side effects: patches @googlemaps/js-api-loader at startup.
import '@/services/googleMapsApiSettings';
import '@/styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root container missing');
createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <HashRouter basename={import.meta.env.PROD ? '/' : '/'}>
        <AppRouter />
      </HashRouter>
    </AppProviders>
  </StrictMode>,
);
